import { createDynamicSlice } from ".";
import { fileUploadThunk } from "../thunks/fileUploadThunk";


export const fileUploadSlice = createDynamicSlice({
  name: "fileUpload",
  thunk: fileUploadThunk,
  listMode: false,
  resetActionName: "resetFileUpload",
});

export const fileUploadReducer = fileUploadSlice.reducer;
export const { resetFileUpload } = fileUploadSlice.actions;
